import React, {
  // useEffect,
  useState
} from "react";
import { fetcherhn } from "../../services/fectcher";
import { useLocation, useNavigate } from "react-router-dom";
import useSWR from "swr";
import {
  Button,
  Drawer,
  Popconfirm,
  Skeleton,
  Space,
  Table,
  Tooltip,
} from "antd";
import { IoArrowBackCircle } from "react-icons/io5";
import Search from "antd/es/transfer/search";

import { FaEdit, FaRegTrashAlt } from "react-icons/fa";

import { WarningOutlined } from "@ant-design/icons";
import CoderReviewForm from "./CoderReviewForm";
import useSWRImmutable from "swr/immutable";
import { usePickList } from "../../services/queries";
import dayjs from "dayjs";
import {
  deleteCoderReview,
  // postCoderStatus
} from "../../api/CoderReviewApi";
import { openNotification } from "../../common/elements/myNotification";
import PatientBanner from "../../common/elements/PatientBanner";
// import MyBackdropSpinner from "../../common/elements/myBackdropSpinner";
// import { postVisitTracking } from "../../api/VisitTrackingApi";

const CoderReviewPatient = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { patientData } = location.state || {};

  const initialReqState = {
    key: "",
    guid: "",
    mbi: patientData?.mbi,
    performyr: location?.state?.year,
    icd10Code: "",
    validationStatusLabel: "",
    validationStatusValue: "",
    noteTypeLabel: "",
    noteTypeValue: "",
    renderProvider: "",
    dateOfService: "",
    createdBy: sessionStorage?.getItem("userName") || "",
    modifiedBy: "",
  };

  const { data: icd10CodesData } = useSWRImmutable(`geticd10codes`, fetcherhn);

  const {
    data: rafData,
    isLoading: rafDataLoading,
    mutate: refetchRafData,
  } = useSWR(
    `getRecalutedraf?mbi=${patientData?.mbi}&dob=${patientData?.dateOfBirth}&gender=${patientData?.gender}&performyr=${location?.state?.year}`,
    fetcherhn
  );

  const { data, mutate, isLoading } = useSWR(
    `getCodeDetailsforMBI?id=${patientData?.mbi}&performyr=${location?.state?.year}`,
    fetcherhn
  );

  const { data: provList } = useSWRImmutable(
    `GetNpPaList?nppa_for=CODERWORKFLOW`,
    fetcherhn
  );

  const rafDataFlat = { ...rafData?.[0] };

  const validationStatusOptions = usePickList(53)?.data;
  const noteTypeOptions = usePickList(54)?.data;

  const [editRecord, setEditRecord] = useState(initialReqState);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);

  const formattedIcd10Codes = icd10CodesData?.map((icd) => ({
    value: icd.code,
    label: `${icd.code} - ${icd.icdDescription}`,
  }));

  const handleCancel = () => {
    setIsModalOpen(false);
    setEditRecord(initialReqState);
  };

  const handleOk = async (e) => {
    if (e) {
      mutate();
    }
    setIsModalOpen(false);
    setEditRecord(initialReqState);
  };

  const edit = (record) => {
    setIsModalOpen(true);
    setEditRecord(record);
  };

  const providerMap = provList?.reduce((acc, provider) => {
    acc[provider.value] = provider.label;
    return acc;
  }, {});

  const columns = [
    {
      title: "ICD-10 Details",
      dataIndex: "icd10Code",
      render: (text, record) => {
        return (
          <>
            <div>
              {text} - {record?.icdDescription}
            </div>
          </>
        );
      },
    },
    {
      title: "HCC Details",
      dataIndex: "hccCode",
      render: (text, record) => {
        return (
          <>
            <div>
              {text} - {record?.hccDescription}
            </div>
          </>
        );
      },
    },
    {
      title: "Relative Factor",
      dataIndex: "relativeFactor",
      width: 90,
    },
    {
      title: "Validation Status",
      dataIndex: "validationStatusLabel",
      width: 120,
    },
    {
      title: "Note Type",
      dataIndex: "noteTypeLabel",
    },
    {
      title: "Rendering Provider",
      dataIndex: "renderProvider",
      render: (value) => providerMap?.[value] || value,
    },

    {
      title: "Date of Service",
      dataIndex: "dateOfService",
      width: 110,
      render: (text) => {
        if (text && dayjs(text).isValid()) {
          const formattedDate = dayjs(text).format("YYYY-MM-DD");
          return formattedDate === "1900-01-01" ? "" : formattedDate;
        }
        return "";
      },
    },
    {
      key: "key",
      title: "Operation",
      dataIndex: "guid",
      fixed: "right",
      width: 100,
      render: (_, record) => (
        <div>
          <Space>
            <Tooltip title="Edit">
              <FaEdit
                size={20}
                className=" tw-cursor-pointer"
                onClick={() => edit(record)}
                color="blue"
              />
            </Tooltip>
            <Tooltip title="Delete">
              <Popconfirm
                title="Ok to Delete?"
                onConfirm={() => handleDelete(record)}
                icon={
                  <WarningOutlined
                    style={{
                      color: "red",
                    }}
                  />
                }
              >
                <FaRegTrashAlt
                  size={20}
                  className=" tw-cursor-pointer"
                  color="red"
                />
              </Popconfirm>
            </Tooltip>
          </Space>
        </div>
      ),
    },
  ];

  const finalResult = data
    ? data?.filter((item) => {
        return [
          "icd10Code",
          "icdDescription",
          "hccCode",
          "hccDescription",
          "relativeFactor",
          "validationStatusLabel",
          "noteTypeLabel",
          "renderProvider",
          "dateOfService",
        ].some((key) => {
          let fieldValue = "";

          // Check if the field is 'renderProvider' to map the value to its label
          if (key === "renderProvider" && providerMap) {
            fieldValue = providerMap[item[key]]?.toLowerCase(); // Convert label to lowercase for search
          } else {
            fieldValue = item[key]
              ?.toString()
              ?.toLowerCase()
              .replace(/_/g, " ");
          }

          return fieldValue?.includes(
            query?.toLowerCase().replace(/_/g, " ") ?? ""
          );
        });
      })
    : data;

  const handleRecalculate = () => {
    refetchRafData();
  };

  const handlePageChange = (page, pageSize) => {
    setPage(page);
    setPageSize(pageSize);
  };

  // const {
  //   data: codeStatusData,
  //   mutate: codeStatusMutate,
  //   isLoading: codeStatusLoading,
  // } = useSWR(
  //   `getPatientCodingStatus?mbi=${patientData?.mbi}&performyr=${location?.state?.year}`,
  //   fetcherhn
  // );

  // const [formData, setFormData] = useState({
  //   key: "",
  //   guid: "",
  //   mbi: patientData?.mbi,
  //   performyr: location?.state?.year,
  //   currentStatus: "",
  // });

  // const handleInputChange = async (name, value) => {
  //   const updatedFormData = {
  //     ...formData,
  //     [name]: value,
  //   };
  //   setFormData(updatedFormData);

  //   const response = await postCoderStatus(updatedFormData);
  //   if (response?.status === 200) {
  //     openNotification(
  //       "success",
  //       "Success",
  //       `Coder Review Status Changed Successfully`,
  //       "bottomRight",
  //       3
  //     );
  //     codeStatusMutate(); // Ensure the latest status is fetched
  //   }

  //   if (value === "Followup") {
  //     const body = {
  //       key: "",
  //       guid: "",
  //       mbi: patientData?.mbi,
  //       performyr: location?.state?.year,
  //       visitTypeLabel: "Follow Up",
  //       visitTypeValue: "followUp",
  //       visitTypeOther: "",
  //       visitStatusLabel: "To Be Scheduled",
  //       visitStatusValue: "toBeScheduled",
  //       visitStatusOther: "",
  //       visitStatusScheduledDate: "",
  //       schedulingDetailsLabel: "",
  //       schedulingDetailsValue: "",
  //       schedulingDetailDate: "",
  //       renderProvider: "",
  //       notes: "Added From Coder Review Follow - Up Automation.",
  //       providerType: "CCMD Provider",
  //       claimType: "",
  //       visitLocation: "",
  //       createdBy: sessionStorage?.getItem("userName"),
  //       modifiedBy: "",
  //     };
  //     postVisitTracking(body);
  //   }
  // };

  // const [timeoutLoading, setTimeoutLoading] = useState(true);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setTimeoutLoading(false);
  //     const codeStatusDataFlat = { ...codeStatusData?.[0] };
  //     if (!codeStatusDataFlat) return;

  //     const updatedFormData = {
  //       key: codeStatusDataFlat?.key || "",
  //       guid: codeStatusDataFlat?.guid || "",
  //       mbi: codeStatusDataFlat?.mbi || patientData?.mbi,
  //       performyr:
  //         codeStatusDataFlat?.performyr?.toString() ||
  //         location?.state?.year?.toString(),
  //       currentStatus: codeStatusDataFlat?.currentStatus || "",
  //     };

  //     if (codeStatusDataFlat?.guid) {
  //       if (
  //         codeStatusDataFlat?.currentStatus !== "Started" &&
  //         codeStatusDataFlat?.currentStatus !== "Completed" &&
  //         codeStatusDataFlat?.currentStatus !== "Followup" &&
  //         data?.length > 0
  //       ) {
  //         updatedFormData.currentStatus = "Started";
  //         postCoderStatus(updatedFormData).then(() => {
  //           openNotification(
  //             "success",
  //             "Success",
  //             "Coder Review Status Changed Successfully",
  //             "bottomRight",
  //             3
  //           );
  //         });
  //       } else if (
  //         data?.length === 0 &&
  //         updatedFormData?.currentStatus !== ""
  //       ) {
  //         updatedFormData.currentStatus = "";
  //         postCoderStatus(updatedFormData).then(() => {
  //           openNotification(
  //             "success",
  //             "Success",
  //             "Coder Review Status Changed Successfully",
  //             "bottomRight",
  //             3
  //           );
  //         });
  //       }
  //     } else if (!updatedFormData?.guid) {
  //       if (updatedFormData?.currentStatus === "" && data?.length > 0) {
  //         updatedFormData.currentStatus = "Started";
  //         postCoderStatus(updatedFormData).then(() => {
  //           openNotification(
  //             "success",
  //             "Success",
  //             "Coder Review Status Changed Successfully",
  //             "bottomRight",
  //             3
  //           );
  //         });
  //       }
  //     }
  //     setFormData(updatedFormData);
  //     codeStatusMutate();
  //   }, 2500);

  //   return () => clearTimeout(timer);
  // }, [codeStatusData, data]);

  const handleDelete = async (record) => {
    const body = {
      ...record,
      performyr: location?.state?.year,
      modifiedBy: sessionStorage.getItem("userName"),
    };
    const deleteResult = await deleteCoderReview(body);
    if (deleteResult.status) {
      mutate();
      // codeStatusMutate();
      openNotification(
        "success",
        "Deleted",
        "Coder Review Deleted Successfully!"
      );
    }
  };

  return (
    <>
      <div className="tw-sticky tw-top-0 tw-z-50 tw-bg-white">
        <div className="tw-flex tw-justify-between">
          <Space>
            <IoArrowBackCircle
              className="tw-cursor-pointer"
              size="2em"
              onClick={() =>
                navigate("/CoderReview", {
                  state: {
                    query: location?.state?.query,
                    page: location?.state?.page,
                    provider: location?.state?.provider,
                    cmsProvider: location?.state?.cmsProvider,
                    status: location?.state?.status,
                    pageSize: location?.state?.pageSize,
                    year: location?.state?.year,
                  },
                })
              }
            />
            <p
              className="pt-3 tw-text-xl"
              style={{
                color: "#D2691E",
                fontWeight: "600",
              }}
            >
              Coder Review for {patientData?.patientName}
            </p>
          </Space>

          <div className="tw-flex tw-justify-end tw-mt-3">
            <Space>
              {/* {timeoutLoading ? (
                <MyBackdropSpinner show={timeoutLoading} />
              ) : (
                <fieldset className="fw-normal">
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="status"
                      id="startedNo"
                      value="notStarted"
                      readOnly
                      checked={!formData?.currentStatus}
                    />
                    <label className="form-check-label" htmlFor="startedNo">
                      Not Started
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="status"
                      id="startedYes"
                      value="Started"
                      disabled={!formData?.currentStatus}
                      checked={formData?.currentStatus === "Started"}
                      onChange={(e) =>
                        handleInputChange("currentStatus", e.target.value)
                      }
                    />
                    <label className="form-check-label" htmlFor="startedYes">
                      In Process
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="status"
                      id="completeYes"
                      value="Completed"
                      checked={formData?.currentStatus === "Completed"}
                      onChange={(e) =>
                        handleInputChange("currentStatus", e.target.value)
                      }
                    />
                    <label className="form-check-label" htmlFor="completeYes">
                      Completed
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="status"
                      id="followupReviewYes"
                      value="Followup"
                      checked={formData?.currentStatus === "Followup"}
                      onChange={(e) =>
                        handleInputChange("currentStatus", e.target.value)
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="followupReviewYes"
                    >
                      Follow Up Review
                    </label>
                  </div>
                </fieldset>
              )} */}
              <Search
                className=" tw-mb-4"
                size="middle"
                placeholder="Search"
                onChange={(e) => setQuery(e.target.value)}
                allowClear
              />
              <Button
                type="primary"
                onClick={() => setIsModalOpen(true)}
                className=""
              >
                Add
              </Button>
            </Space>
          </div>
        </div>
        <PatientBanner patientData={patientData} />
        {rafDataLoading ? (
          <Skeleton active={rafDataLoading} />
        ) : (
          <div className="tw-my-3 tw-w-full tw-p-3 tw-bg-gray-100 tw-rounded-md">
            <div className="tw-flex tw-gap-3 tw-items-stretch tw-w-full">
              {/* Metric Card */}
              <div className="tw-bg-white tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md">
                <div className="tw-p-1 tw-font-semibold tw-whitespace-nowrap">
                  Care Foundation Impact RAF / Count
                </div>
                <div className="tw-p-1">
                  {rafDataFlat?.cceImpactRaf} /{" "}
                  {rafDataFlat?.totalAddDocumented
                    ? `${rafDataFlat?.totalAddDocumented}`
                    : 0}
                </div>
              </div>

              {/* Metric Card */}
              <div className="tw-bg-white tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md">
                <div className="tw-p-1 tw-font-semibold tw-whitespace-nowrap">
                  Added Impact RAF / Count
                </div>
                <div className="tw-p-1">
                  {rafDataFlat?.addImpactRaf
                    ? `${rafDataFlat?.addImpactRaf}`
                    : 0}{" "}
                  / {rafDataFlat?.totalAdd}
                </div>
              </div>

              {/* Metric Card */}
              <div className="tw-bg-white tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md">
                <div className="tw-p-1 tw-font-semibold tw-whitespace-nowrap">
                  Documented Impact RAF / Count
                </div>
                <div className="tw-p-1">
                  {rafDataFlat?.documentedImpactRaf
                    ? `${rafDataFlat?.documentedImpactRaf}`
                    : 0}{" "}
                  /{" "}
                  {rafDataFlat?.totalDocumented
                    ? `${rafDataFlat?.totalDocumented}`
                    : 0}
                </div>
              </div>

              {/* Metric Card */}
              <div className="tw-bg-white tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md">
                <div className="tw-p-1 tw-font-semibold tw-whitespace-nowrap">
                  Recapture Rate
                </div>
                <div className="tw-p-1">
                  {rafDataFlat?.recaptureRate
                    ? `${rafDataFlat?.recaptureRate} %`
                    : 0}
                </div>
              </div>

              {/* Recalculate Button */}
              <div
                className="tw-bg-blue-500 tw-text-white tw-px-3 tw-py-2 tw-flex tw-items-center tw-justify-center tw-font-semibold tw-rounded-md tw-cursor-pointer tw-text-sm"
                onClick={handleRecalculate}
              >
                Re-Calculate
              </div>
            </div>
          </div>

          // <div className="tw-grid tw-my-3 tw-w-full tw-grid-cols-5 tw-gap-4 tw-p-4 tw-bg-gray-100 tw-rounded-md">
          //   <div className="tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md ">
          //     <div className="tw-p-1 tw-font-semibold">
          //       Care Foundation Impact RAF
          //     </div>
          //     <div className="tw-p-1 tw-flex tw-items-center tw-justify-center">
          //       {rafDataFlat?.cceImpactRaf}
          //     </div>
          //   </div>
          //   <div className="tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md ">
          //     <div className="tw-p-1 tw-font-semibold">
          //       Added Impact RAF / Count
          //     </div>
          //     <div className="tw-p-1 tw-flex tw-items-center tw-justify-center">
          //       {rafDataFlat?.addImpactRaf
          //         ? `${rafDataFlat?.addImpactRaf} `
          //         : 0}{" "}
          //       / {rafDataFlat?.totalAdd}
          //     </div>
          //   </div>
          //   <div className="tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md ">
          //     <div className="tw-p-1 tw-font-semibold tw-whitespace-nowrap">
          //       Documented Impact RAF / Count
          //     </div>
          //     <div className="tw-p-1 tw-flex tw-items-center tw-justify-center">
          //       {rafDataFlat?.documentedImpactRaf
          //         ? `${rafDataFlat?.documentedImpactRaf} `
          //         : 0}
          //       /{" "}
          //       {rafDataFlat?.totalDocumented
          //         ? `${rafDataFlat?.totalDocumented} `
          //         : 0}
          //     </div>
          //   </div>
          //   <div className="tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md ">
          //     <div className="tw-p-1 tw-font-semibold">Recapture Rate</div>
          //     <div className="tw-p-1 tw-flex tw-items-center tw-justify-center">
          //       {rafDataFlat?.recaptureRate
          //         ? `${rafDataFlat?.recaptureRate} %`
          //         : 0}
          //     </div>
          //   </div>
          //   {/* <div className="tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md ">
          //     <div className="tw-p-1 tw-font-semibold">Added Impact RAF</div>
          //     <div className="tw-p-1 tw-flex tw-items-center tw-justify-center">
          //       {rafDataFlat?.addImpactRaf
          //         ? `${rafDataFlat?.addImpactRaf} `
          //         : 0}
          //     </div>
          //   </div> */}
          //   {/* <div className="tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md ">
          //     <div className="tw-p-1 tw-font-semibold">Total Documented</div>
          //     <div className="tw-p-1 tw-flex tw-items-center tw-justify-center">
          //       {rafDataFlat?.totalDocumented
          //         ? `${rafDataFlat?.totalDocumented} `
          //         : 0}
          //     </div>
          //   </div>
          //   <div className="tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md ">
          //     <div className="tw-p-1 tw-font-semibold">
          //       Documented Impact RAF
          //     </div>
          //     <div className="tw-p-1 tw-flex tw-items-center tw-justify-center">
          //       {rafDataFlat?.documentedImpactRaf
          //         ? `${rafDataFlat?.documentedImpactRaf} `
          //         : 0}
          //     </div>
          //   </div> */}
          //   {/* <div className="tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md ">
          //     <div className="tw-p-1 tw-font-semibold">
          //       Total Added and Documented
          //     </div>
          //     <div className="tw-p-1 tw-flex tw-items-center tw-justify-center">
          //       {rafDataFlat?.totalAddDocumented
          //         ? `${rafDataFlat?.totalAddDocumented} `
          //         : 0}
          //     </div>
          //   </div> */}
          //   <div
          //     className="tw-bg-blue-500 tw-text-white tw-flex tw-items-center tw-justify-center tw-font-semibold tw-rounded-md tw-cursor-pointer "
          //     onClick={handleRecalculate}
          //   >
          //     Re-Calculate
          //   </div>
          // </div>
        )}
      </div>

      {isModalOpen && (
        <Drawer
          open={isModalOpen}
          title="Add/Update Coder Review"
          onClose={handleCancel}
          width={600}
        >
          <CoderReviewForm
            icd10Codes={formattedIcd10Codes}
            validationStatusOptions={validationStatusOptions}
            noteTypeOptions={noteTypeOptions}
            editRecord={editRecord}
            callback={handleOk}
            provList={provList}
            performanceYear={location?.state?.year}
          />
        </Drawer>
      )}
      {isLoading ? (
        <Skeleton active={isLoading} />
      ) : (
        <Table
          dataSource={finalResult}
          columns={columns}
          virtual
          bordered
          pagination={{
            current: page,
            pageSize: pageSize,
            onChange: (page, pageSize) => handlePageChange(page, pageSize),
            showTotal: (total, [from, to]) =>
              `Showing ${from} - ${to} of ${total} items`,
          }}
        />
      )}
    </>
  );
};

export default CoderReviewPatient;
